<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印装箱单"
      class="packMarkPrintModal"
      width="500px"
      top="5vh">
    <!--    50*25-->
    <!--    <div id="labelSettings">-->
    <!--      <el-form :inline="true" label-width="140px">-->
    <!--        <el-form-item label="产品名称">-->
    <!--          <el-input v-model="printName"/>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="LOGO">-->
    <!--          <el-checkbox v-model="logoVisible"/>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="数量">-->
    <!--          <el-input v-model="printQty"/>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="规格型号">-->
    <!--          <el-input v-model="printType"/>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="DATE">-->
    <!--          <el-input v-model="printDate"/>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item label="条码">-->
    <!--          <el-input v-model="barCodeText">-->
    <!--            <el-button type="primary" slot="append" @click="codeChange">重新生成</el-button>-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--    </div>-->
    <!--    <el-divider/>-->
    <div id="labelContentPackMark">
      <div v-for="(info,index) in productInfos" :key="index" id="printPackMark">

        <div style="margin:0px 5px 0px 5px;text-align: center;">
          <div style="text-align: center;font-size: 20px;font-weight: bold;">
            装箱清单
          </div>
          <div style="display: flex;">
            <div style="font-weight: bold;">产品名称:</div>
            <div style="font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.5px;">
              {{ info.materialName }}
            </div>
          </div>
          <div style="display: flex;">
            <div style="font-weight: bold;">规格型号:</div>
            <div style="font-family: 'Arial Narrow';font-weight: bold;letter-spacing: -0.5px;">
              {{ info.specification }}
            </div>
          </div>
          <div style="display: flex;">
            <div style="font-weight: bold;">箱号:</div>
            <div style="font-weight: bold;">{{ info.caseQty }}-{{ info.subCaseNo }}</div>
          </div>
          <div style="display: flex;">
            <div style="font-weight: bold;">装箱日期:</div>
            <div style="font-weight: bold;">{{ printDate }}</div>
            <div style="text-align: right;" :id="(() => 'barCode_'+info.pkId)()"/>
          </div>

        </div>

      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
import moment from "moment";

export default {
  data() {
    return {
      dialogVisible: false,
      logoVisible: true,
      printType: "",
      printQty: "",
      printDate: "",
      printName: "",
      ids: [],
      productInfos: [],
      logoSrc: "",
      barCodeText: "",
      printOption: {
        id: "labelContentPackMark",
        preview: false,
        popTitle: "打印",
        previewPrintBtnLabel: "打印",
        clickMounted() {
        },
      },
    };
  },

  methods: {
    open(infos) {
      console.log(infos);
      this.dialogVisible = true;
      this.productInfos = infos;
      this.printQty = infos.length;
      this.printDate = moment(new Date()).format("YYYY-MM-DD");
      this.$nextTick(() => {
        this.setBarcode();
      });

    },

    setBarcode() {
      this.ids = [];
      for (var i = 0; i < this.printQty; i++) {
        document.getElementById("barCode_" + this.productInfos[i].pkId).innerHTML = "";
        this.bindQRCode(this.productInfos[i].packBarcode, this.productInfos[i].pkId);
        this.ids.push(this.productInfos[i].pkId);
      }
    },

    bindQRCode(row, id) {
      let text = row;
      new QRCode(document.getElementById("barCode_" + id), {
        text: text,
        width: 40,
        height: 40,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    print() {
      this.$http.get("basic", `packMarkDetails/updatePrintSn/${this.ids}`).then(() => {
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.packMarkPrintModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.packMarkPrintModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.packMarkPrintModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 90%;
}

.packMarkPrintModal .el-divider--horizontal {
  margin: 10px 0;
}

.packMarkPrintModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style lang="scss" scoped>
#printPackMark {
  width: 80mm;
  height: 36mm;
  margin: 0 auto;
  //margin-top: 1.5mm;
  page-break-before: always;
  //font-size: 10px;
  align-items: center;

}
</style>
